import { LinearFilter, RGBFormat, Texture } from "three"

class VideoTexture extends Texture {
    isVideoTexture: boolean

    constructor(
        video: HTMLVideoElement,
        mapping?: THREE.Mapping | undefined,
        wrapS?: THREE.Wrapping | undefined,
        wrapT?: THREE.Wrapping | undefined,
        magFilter?: THREE.TextureFilter | undefined,
        minFilter?: THREE.TextureFilter | undefined,
        format?: THREE.PixelFormat | undefined,
        type?: THREE.TextureDataType | undefined,
        anisotropy?: number | undefined
    ) {
        super(
            video,
            mapping,
            wrapS,
            wrapT,
            magFilter,
            minFilter,
            format,
            type,
            anisotropy
        )

        this.isVideoTexture = true

        this.format = format !== undefined ? format : RGBFormat

        this.minFilter = minFilter !== undefined ? minFilter : LinearFilter
        this.magFilter = magFilter !== undefined ? magFilter : LinearFilter

        this.generateMipmaps = false
    }

    clone() {
        const constructor = this.constructor as typeof VideoTexture
        return new constructor(this.image).copy(this)
    }

    update() {
        const video = this.image

        if (video.readyState >= video.HAVE_CURRENT_DATA) {
            this.needsUpdate = true
        }
    }
}

export { VideoTexture }
